"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIsFlowpublished = exports.updateDomainRetrievalStatus = exports.updateNeedsAuth = exports.setOutcomeDomainError = exports.setOutcomeList = exports.updateObjective = exports.setSubspace = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * Best practice of Redux duck pattern
 * https://github.com/erikras/ducks-modular-redux
 */
var toolkit_1 = require("@reduxjs/toolkit");
var Utils_1 = require("../../util/Utils");
var initialState = {
    subspace: Utils_1.SubspaceType.Connect,
    objective: {
        dataSourceId: 'Select',
        dataSourceVersionId: '',
        flowId: '',
        outcomeField: 'Select a field',
        outcomeType: '',
        predictionType: '',
        goal: 'Maximize',
        algorithm: 'GLM',
        successValue: '',
        failureValue: '',
        domain: [],
    },
    needsAuth: false,
    outcomeList: undefined,
    outcomeDomainError: '',
    domainRetrievalStatus: Utils_1.DomainRetrievalStatus.Unknown,
    flowId: '',
    flowLuId: '',
    isFlowpublished: true,
};
var subspaceSlice = (0, toolkit_1.createSlice)({
    name: 'subspace',
    initialState: initialState,
    reducers: {
        // In this pattern action type is defined like slice name/reducer name(in this case the first action type is "subspace/setSubspace"),
        setSubspace: function (state, action) {
            state.subspace = action.payload;
        },
        updateObjective: function (state, action) {
            var payload = action.payload;
            var field = payload.value;
            var type = payload.type;
            state.objective[type] = field;
        },
        updateNeedsAuth: function (state, action) {
            state.needsAuth = action.payload;
        },
        setOutcomeList: function (state, action) {
            state.outcomeList = action.payload;
        },
        setOutcomeDomainError: function (state, action) {
            state.outcomeDomainError = action.payload;
        },
        updateDomainRetrievalStatus: function (state, action) {
            state.domainRetrievalStatus = action.payload;
        },
        updateIsFlowpublished: function (state, action) {
            state.isFlowpublished = action.payload;
        },
    },
});
exports.setSubspace = (_a = subspaceSlice.actions, _a.setSubspace), exports.updateObjective = _a.updateObjective, exports.setOutcomeList = _a.setOutcomeList, exports.setOutcomeDomainError = _a.setOutcomeDomainError, exports.updateNeedsAuth = _a.updateNeedsAuth, exports.updateDomainRetrievalStatus = _a.updateDomainRetrievalStatus, exports.updateIsFlowpublished = _a.updateIsFlowpublished;
exports.default = subspaceSlice.reducer;
//# sourceMappingURL=SubspaceSlice.js.map